import React, { createElement } from 'react';
const ErrorComponent = (props, ref) => {
    const { errmsg, ...other } = props;
    return createElement("h1", Object.assign({ ref: ref }, other), errmsg || '渲染错误,请使用最新组件或修改配置');
};
export default React.forwardRef(ErrorComponent);
